export default __webpack_public_path__ + "static/media/NV1.a413c986.jpg";